export default "__VITE_ASSET__ZwhOS8bq__"